import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BrainCircuit, Landmark, Boxes, Glasses, HeartPulse, Bot, Gamepad2, GraduationCap, MapPin } from 'lucide-react';

const sectorIcons = [BrainCircuit, Landmark, Boxes, Glasses, HeartPulse, Bot, Gamepad2, GraduationCap];

export const BenefitsSection = () => {
  const { language, t } = useLanguage();
  return (
    <>
      <section id="sectors" className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`max-w-4xl ${language === 'ar' ? 'ml-auto text-right' : ''}`}>
            <span className="inline-block text-sm uppercase tracking-[0.14em] font-bold text-[#B78321] mb-4">{t.sectors.eyebrow}</span>
            <h2 className="text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">{t.sectors.title}</h2>
          </div>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {t.sectors.items.map((item,index) => {
              const Icon = sectorIcons[index];
              return (
                <div key={item} className={`min-h-32 rounded-2xl bg-gradient-to-br from-[#062A4F] to-[#0B5F97] p-5 text-white flex flex-col justify-between ${language === 'ar' ? 'text-right' : ''}`}>
                  <Icon className={`w-7 h-7 text-[#9CDCF6] ${language === 'ar' ? 'mr-auto' : ''}`} />
                  <span className="font-bold text-lg">{item}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section-padding bg-[#F5F8FB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className={`text-3xl sm:text-5xl font-bold text-slate-900 ${language === 'ar' ? 'text-right' : ''}`}>{t.audiences.title}</h2>
          <div className="mt-10 grid lg:grid-cols-3 gap-5">
            {t.audiences.items.map(([title,body],index) => {
              const ids=['startups','investors','partners'];
              return (
                <article id={ids[index]} key={title} className={`rounded-2xl bg-white border border-slate-200 p-7 shadow-sm ${language === 'ar' ? 'text-right' : ''}`}>
                  <h3 className="text-2xl font-bold text-[#0B4DA2]">{title}</h3>
                  <p className="mt-4 text-slate-600 leading-relaxed">{body}</p>
                </article>
              );
            })}
          </div>

          <div className="mt-12 rounded-3xl bg-[#062A4F] text-white p-8 sm:p-10 grid lg:grid-cols-[.75fr_1.25fr] gap-8 items-center">
            <div className={`flex items-center gap-4 ${language === 'ar' ? 'lg:order-2 justify-end' : ''}`}>
              <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center">
                <MapPin className="w-8 h-8 text-[#9CDCF6]" />
              </div>
              <span className="text-sm uppercase tracking-[0.14em] font-bold text-[#9CDCF6]">{t.rak.eyebrow}</span>
            </div>
            <div className={language === 'ar' ? 'lg:order-1 text-right' : ''}>
              <h3 className="text-3xl font-bold">{t.rak.title}</h3>
              <p className="mt-3 text-slate-200 leading-relaxed">{t.rak.body}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={language === 'ar' ? 'text-right' : ''}>
            <span className="inline-block text-sm uppercase tracking-[0.14em] font-bold text-[#B78321] mb-4">{t.faq.eyebrow}</span>
            <h2 className="text-3xl sm:text-5xl font-bold text-slate-900">{t.faq.title}</h2>
          </div>
          <div className="mt-10 space-y-3">
            {t.faq.items.map(([q,a]) => (
              <details key={q} className={`group rounded-2xl border border-slate-200 bg-white p-5 ${language === 'ar' ? 'text-right' : ''}`}>
                <summary className="cursor-pointer font-bold text-slate-900 text-lg list-none flex justify-between items-center gap-4">
                  <span>{q}</span><span className="text-[#0B4DA2] text-2xl group-open:rotate-45 transition-transform">+</span>
                </summary>
                <p className="mt-4 text-slate-600 leading-relaxed">{a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
